import React, { createContext, useCallback, useEffect, useState } from "react";
import { toast } from "react-toastify";

const MyContext = createContext();
const MyContextProvider = ({ children }) => {
  const [token, setToken] = useState(localStorage.getItem("token"));
  const [role, setRole] = useState(localStorage.getItem("role"));
  const [tabContent, setTabContent] = useState("home");
  const [theme, setTheme] = useState(localStorage.getItem("theme"));
  const [isMenuExpanded, setIsMenuExpanded] = useState(false);

  const [adminToken, setAdminToken] = useState(
    localStorage.getItem("adminToken")
  );

  const [clientDetails, setClientDetails] = useState(
    JSON.parse(localStorage.getItem("clientDetails") || "{}")
  );


  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);

  const [user, setUser] = useState(
    JSON.parse(localStorage.getItem("userDetails") || "{}")
  );
  const [companyData, setCompanyData] = useState(
    JSON.parse(localStorage.getItem("companyData") || "{}")
  );

    const updateUser = (newData) => {
      setUser(newData);
      localStorage.setItem("userDetails", JSON.stringify(newData));
    };

  const updateRole = (newData) => {
    setRole(newData);
    localStorage.setItem("role", newData);
  };


  const updateCompanyData = (newData) => {
    setCompanyData(newData);
    localStorage.setItem("companyData", JSON.stringify(newData));
  };

  const updateToken = (newData) => {
    console.log("newData: ", newData);
    setToken(newData);
    localStorage.setItem("token", newData);
  };

  const updateClient = (newData) => {
    setClientDetails(newData);
    localStorage.setItem("clientDetails", JSON.stringify(newData));
  };

  const updateAdminToken = (newData) => {
    setAdminToken(newData);
    localStorage.setItem("adminToken", newData);
  };
  const updateTheme = (newData) => {
    setTheme(newData);
    localStorage.setItem("theme", newData);
    // Update root CSS variables based on theme
    if (newData === 'light') {
      document.documentElement.style.setProperty('--color-page', '#ECF0F3');
      document.documentElement.style.setProperty('--color-heading', '#141414');
      document.documentElement.style.setProperty('--color-gray', '#5d6570');
      document.documentElement.style.setProperty('--color-body', '#2a2d31');
      document.documentElement.style.setProperty('--color-gray-2', 'linear-gradient(145deg, #e2e8ec, #ffffff)');
      document.documentElement.style.setProperty('--color-border', '#dce1e4');
      document.documentElement.style.setProperty('--stroke-dark-100', '#dce1e4');
      document.documentElement.style.setProperty('--stroke-gr', 'linear-gradient(317deg, #13fdfd 0%, rgba(19, 215, 253, 1) 50%, rgba(19, 191, 253, 1) 62.96%, #139bfd 100%)');
      document.documentElement.style.setProperty('--shadow-white', '5px 5px 15px #D1D9E6, -5px -5px 15px #ffffff');
      document.documentElement.style.setProperty('--gradient-white', 'linear-gradient(145deg, #e2e8ec, #ffffff)');
      document.documentElement.style.setProperty('--theme-gradient', 'linear-gradient(312deg, #f5719a 0%, #4C4685 100%)');
    } else {
      const darkThemeVars = {
        '--color-page': '#010A10',
        '--color-primary': 'var(--color-subtitle)',
        '--color-primary-alt': 'var(--color-primary)',
        '--color-primary-2nd': '#FF494A',
        '--color-primary-3rd': '#FDC448',
        '--color-primary-4th': '#0071ff',
        '--color-secondary': '#010a10',
        '--color-white': '#ffffff',
        '--color-gray': '#bebebe',
        '--color-gray-2': '#06131b',
        '--color-subtitle': '#4C4685',
        '--stroke-dark-100': '#081722',
        '--background-color-1': '#24243557',
        '--background-color-2': '#13131d',
        '--background-color-3': '#151521',
        '--background-color-4': '#242435',
        '--background-color-5': '#EDF5FF',
        '--color-card-wrapper': '#010a10',
        '--color-card': '#06131b',
        '--gradient-box': 'linear-gradient(to right, var(--color-primary), #5f3b78)',
        '--gradient-one': 'linear-gradient(to right bottom, #4C4685, #1273EB)',
        '--gradient-two': 'linear-gradient(to right, #ED145B, #4A11EB)',
        '--gradient-three': 'linear-gradient(to right, #03041c, #0612b3)',
        '--text-gradient-one': 'linear-gradient(to right, #4C4685, #4A11EB)',
        '--stroke-gr': 'linear-gradient(317deg, var(--color-subtitle) 0%, rgba(19, 215, 253, 0.2) 38.23%, rgba(19, 191, 253, 0.2) 62.96%, var(--color-primary-alt) 100%)',
        '--stroke-gradient-2': 'radial-gradient(92.46% 222.14% at 15.65% -7.58%, rgba(127, 226, 251, 0.20) 0%, rgba(127, 226, 251, 0.02) 100%)',
        '--icon-gradient': 'linear-gradient(312deg, #f5719a 0%, #4C4685 100%)',
        '--shadow-1': '0 2px 22px #13fdfd7d',
        '--theme-gradient': "linear-gradient(312deg, #f5719a 0%, #4C4685 100%)",
        '--color-heading': '#ffffff',
        '--color-body': '#d6d6d6',
        '--color-dark': '#1d1d1d',
        '--color-text-1': '#DEDEDE',
        '--color-border': 'var(--bs-danger)',
        '--color-border-2': '#ffffff80',
        '--color-border-3': '#ffffff0f'
      };

      Object.entries(darkThemeVars).forEach(([property, value]) => {
        document.documentElement.style.setProperty(property, value);
      });
    }
  };

  return (
    <MyContext.Provider
      value={{
        token,
        updateToken,
        user,
        updateUser,
        setOpen,
        open,
        loading,
        setLoading,
        clientDetails,
        updateClient,
        adminToken,
        updateAdminToken,
        companyData,
        role,
        updateRole,
        updateCompanyData,
        tabContent,
        setTabContent,
        theme,
        updateTheme,
        isMenuExpanded,
        setIsMenuExpanded,
      }}
    >
      {children}
    </MyContext.Provider>
  );
};

export { MyContext, MyContextProvider };
